import React, { useContext, useState } from "react";
import Navbar from "../components/HomeComponents/Navbar";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import TextError from "../helper/TextError";
import ContactSuccess from "../components/ContactComponents/ContactSuccess";
import authAPI from "../api/auth";
import Button from "../components/GeneralComponents/Button";
import { toast } from "react-hot-toast";
import { getServerError } from "../helper/misc";
import { useAuth } from "../helper/auth";
import { LogContent } from "../helper/context";
import Modal from "../components/Modal/Modal";
import SEO from "../components/Seo/Seo";

function Contact(props) {
  const auth = useAuth();
  const { displayMeta } = useContext(LogContent);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const nextStep = () => {
    setStep((step) => step + 1);
  };

  const initialValues = {
    email: "",
    phoneNumber: "",
    message: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid Email Format!")
      .required("Email is Required!"),
    phoneNumber: Yup.number().required("Required!"),
    message: Yup.string().required("Enter Your Message"),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      await authAPI.contact({
        email: values.email,
        phone_number: values.phoneNumber,
        message: values.message,
      });
      setLoading(false);
      nextStep();
    } catch (e) {
      toast.error(getServerError(e));
      setLoading(false);
    }
    // to contain logic to send form data to backend
  };

  switch (step) {
    default:
      return (
        <>
          <div>
            <SEO title="Contact Us" type="contact" />
            <div>
              <Navbar />
              <div className="bg-[#F3F5F9] lg:mt-[-2rem] md:rounded-3xl border h-screen lg:mx-auto pb-20 lg:scale-[80%]">
                <h2 className="pt-10 lg:pt-20 font-semibold text-3xl text-center">
                  Contact Us
                </h2>
                <div className="mt-6 md:mt-8 lg:mt-16">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                  >
                    {(formik) => (
                      <Form className="flex flex-col justify-center items-center">
                        <Field
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Enter Email"
                          className="w-80 md:w-[450px] outline-pw-blue pl-8 py-2 border border-2 rounded-2xl bg-gray-100"
                        />
                        <ErrorMessage name="email" component={TextError} />
                        <Field
                          type="text"
                          name="phoneNumber"
                          id="phoneNumber"
                          placeholder="Enter Phone Number"
                          className="w-80 md:w-[450px] outline-pw-blue pl-8 py-2 border border-2 rounded-2xl bg-gray-100 mt-8"
                        />
                        <ErrorMessage
                          name="phoneNumber"
                          component={TextError}
                        />
                        <Field
                          as="textarea"
                          name="message"
                          id="message"
                          placeholder="How can we help you?"
                          className="w-80 md:w-[450px] outline-pw-blue pl-8 py-2 border border-2 rounded-2xl bg-gray-100 mt-8 h-24"
                        />
                        <ErrorMessage name="message" component={TextError} />
                        <Button
                          type="submit"
                          loading={loading}
                          text="Continue"
                        />
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
          {displayMeta && auth.user && <Modal />}
        </>
      );
    case 2:
      return (
        <>
          <ContactSuccess />;{displayMeta && auth.user && <Modal />}
        </>
      );
  }
}

export default Contact;
